import {
  buildSignature,
  prepareCryptoControlBlock,
  signCertificate,
} from "@rshbintech.dboul/utils";
import { bulkSignOrchestratorApi } from "@rshbintech.dboul/http";
import { logger } from "@rshbintech.dboul/logger";
import { BatchedDocumentsItemMap } from "../types";
import {
  DOCUMENT_SIGNING_ERROR,
  DOCUMENT_SIGNING_STAGES,
  SYSTEM_SHORT_NAMES,
} from "../constants";
import { Base64 } from "../../signing-document/utils";
import { cleanLineBreaksFromSignature } from "./clean-line-breaks";

// Локальное подписание документов через КриптоПРО
// Возвращает объект с парами <ID документа>:<документ SignedDocument>
export const signDocumentsCertificate = async (
  certificateId: string,
  documents: BatchedDocumentsItemMap
) => {
  const promiseQueue: Promise<string>[] = [];

  for (const documentId in documents) {
    const document = documents[documentId];

    if (
      document?.signatureInfo.signingStage === DOCUMENT_SIGNING_STAGES.GOT_CCB
    ) {
      const localSigning = new Promise<string>((resolve, reject) => {
        const setError = (error: string) => reject(error);
        const ccbData = document?.signatureInfo?.ccbInfo?.data;

        if (!ccbData) {
          setError(DOCUMENT_SIGNING_ERROR);

          return;
        }

        const ccbDataBySystem =
          document.systemShortName === SYSTEM_SHORT_NAMES.MONOLITH
            ? JSON.parse(ccbData || "{}")
            : ccbData;

        const ccb = prepareCryptoControlBlock(ccbDataBySystem);
        const setSigningMessage = (message: string) => resolve(message);

        if (document.systemShortName === SYSTEM_SHORT_NAMES.MICROSERVICE) {
          // Подписание для МС
          signCertificate(
            certificateId,
            ccb,
            setSigningMessage,
            setError,
            true
          );
        } else {
          const setSignature = (signingMessage: string) => {
            buildSignature(certificateId, signingMessage, setSigningMessage);
          };

          // Подписание для Монолита
          signCertificate(certificateId, ccb, setSignature, setError, true);
        }
      });

      localSigning
        .then((signature) => {
          // Убираем перенос строк после кодирования в cryptopro только для МС
          const cleanedSignature = cleanLineBreaksFromSignature(signature);

          document.signatureInfo = {
            ...document.signatureInfo,
            signature:
              document.systemShortName === SYSTEM_SHORT_NAMES.MONOLITH
                ? Base64.encode(signature)
                : cleanedSignature,
            signingStage: DOCUMENT_SIGNING_STAGES.SIGNED_LOCALLY,
          };
        })
        .catch(async (error) => {
          const errorMessage = error || "";

          document.signatureInfo = {
            ...document.signatureInfo,
            error: errorMessage,
            signingStage: DOCUMENT_SIGNING_STAGES.FINISHED_WITH_ERROR,
          };

          const id = document.id;
          const system = document.systemShortName;
          const taskId = document.signatureInfo.ccbInfo?.taskId || "";
          const type =
            system === SYSTEM_SHORT_NAMES.MICROSERVICE
              ? document.type?.code
              : "";

          try {
            const errorText = errorMessage.toString();

            await bulkSignOrchestratorApi.api.setSigningErrors(taskId, {
              documents: [{ id, system, type, errorText }],
            });
          } catch (error) {
            document.signatureInfo = {
              ...document.signatureInfo,
              error: errorMessage,
              signingStage: DOCUMENT_SIGNING_STAGES.FINISHED_WITH_ERROR,
            };

            logger.sendError(error);
          }
        });

      promiseQueue.push(localSigning);
    }
  }

  return Promise.allSettled(promiseQueue).then(() => documents);
};
